import { Component } from 'react';
import { AlertTriangle, RefreshCw, Image } from 'lucide-react';
import { Button } from './ui/button';
import { asset } from './studyAssets';

export class ViewerErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <section className="viewer-recovery" role="alert" data-testid="viewer-module-error">
      <AlertTriangle size={26}/>
      <div>
        <h2 data-testid="viewer-module-error-title">The 3D viewer couldn’t open.</h2>
        <p data-testid="viewer-module-error-message">A newer study version may be available, or the connection was interrupted. Your drawings and rendered views are still available.</p>
        <div className="page-downloads">
          <Button data-testid="viewer-module-reload" className="download-link primary-download" onClick={() => window.location.reload()}><RefreshCw size={17}/>Reload viewer</Button>
          <a data-testid="viewer-module-render-fallback" className="download-link" href={asset('concept-isometric-right.png')} target="_blank" rel="noreferrer"><Image size={17}/>Open rendered view</a>
          <a data-testid="viewer-module-pdf-fallback" className="download-link" href={asset('isometric-views.pdf')} download>Download views PDF</a>
        </div>
      </div>
    </section>;
  }
}